import React, { Component } from 'react';
import Circular from '../Circular/Circular';
import Table from 'components/Table/Table';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import DateFnsUtils from '@date-io/date-fns';
import FormControl from '@material-ui/core/FormControl';
import Button from "components/CustomButtons/Button.js";
import IconButton from '@material-ui/core/IconButton';
import Visibility from "@material-ui/icons/Visibility";
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CardIcon from "components/Card/CardIcon.js";
import { Person, Phone, Description, Today, Update, Info, ViewModule } from '@material-ui/icons';
import { Icon } from "@material-ui/core";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { getCustomer, getOrderByCustomerId } from '../../services/orders/orders';
import { getLockersById } from '../../services/lockers/lockers';
import SearchInfo from './SearchInfo';
import ToggleButton from 'components/CustomButtons/ToggleButton';
import Orders from 'components/Orders/Orders';
import './style.css';
import Moment from 'react-moment';
import moment from 'moment';
Moment.globalMoment = moment
Moment.globalLocale = 'pt-br'


const useStyles = theme => ({
    root: {
        '& .MuiFormControl-root': {
            margin: theme.spacing(2),
            width: 200,
            marginLeft: "75px"
        }
    },
    rootCircular: {
        flexGrow: 1,
        backgroundColor: "#f1f1f2"
      },
    green: {
        '& label.Mui-focused': {
            color: 'green'
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        }
    },
    iconView : {
      color: "white !important"
    },
    rowIcon: {
        display: "flex",
        alignItems: "center"
    },
    note: {
        lineHeight: '0.3em'
    }
  });


class SearchSocicam extends Component {
    constructor(props) {
        super(props);
        this.handleDateChangeFrom = this.handleDateChangeFrom.bind(this);
        this.handleDateChangeTo = this.handleDateChangeTo.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.returnFilter = this.returnFilter.bind(this);
        this.handleClean = this.handleClean.bind(this);
        this.getcustomerById = this.getcustomerById.bind(this);
        this.setDialog = this.setDialog.bind(this);
        this.state = {
            circular: false,
            dateFrom: null,
            dateTo: null,
            status: null,
            documentValue: null,
            cpf: null,
            data: [],
            color: ["success"],
            nothingFound: false,
            statuses: [ 
                {
                  value: 'available',
                  label: 'Disponível',
                },
                {
                  value: 'reserved',
                  label: 'Reservado',
                },
                ,
                {
                  value: 'collected',
                  label: 'Coletado',
                },
                {
                  value: 'allocated',
                  label: 'Alocado',
                },
                {
                  value: 'unavailable',
                  label: 'Indisponível',
                },
                {
                  value: 'to_be_free',
                  label: 'Pronto para ser Liberado',
                },
                {
                  value: 'dirty',
                  label: 'Sujo',
                },
                {
                   value: null,
                   label: '-'
                },
            ],
            showInfo: false,
            currentData: null,
            togglePosition: 'left'
        }
    }

    handleDateChangeFrom(e) {
        this.setState({dateFrom: e});
    };

    handleDateChangeTo(e) {
        this.setState({dateTo: e});
    };

    handleChange(event) {
        let e = (event.target.id) ? event.target.id : event.target.name;

        switch (e) {
            case 'docValue':
                this.setState({ documentValue: event.target.value })
                break;
            case 'status':
                this.setState({ status:event.target.value })
                break;
            case 'cpf':
                this.setState({ cpf:event.target.value })
                break;
            default:
                this.setState({ size: event.target.value })
                break;
        }
    }

    handleSearch() {
        let { lockerId } = this.props;
        let { status, dateTo, dateFrom  } = this.state;

        this.setState({circular: true});
        getCustomer(this.returnFilter(), (data) => {

            if(data.length < 1){
                this.setState({circular: false, data, nothingFound: true}); 
            }
            new Promise((resolve, reject) => {
                getLockersById((lockerId), (locker) => {
                    data.map((d, index) => {
                        getOrderByCustomerId(d.id, status, lockerId, (orders) => {
                            if(orders.length > 0) {
                                orders.map(o => {
                                    if(locker.name)
                                        Object.assign(d, { status: o.status, createdAto: o.createdAt, 
                                                            updatedAto: o.updatedAt, lockerName: locker.name, 
                                                            carrierId: o.carrierId, collectedAt: o.collectedAt,
                                                            reservedAt: o.reservedAt
                                                        });
                                    if(index + 1 ===data.length) { 
                                        resolve(data);
                                    } 
                                });
                                
                            } else {
                                if(index + 1 ===data.length) {
                                    resolve(data);
                                }
                            }
                        })
                    }); 
                });
            }).then(data => {

                setTimeout(() => {
                    if(dateFrom && dateTo) {
                        data = data.filter(d => {
                            if(d.createdAto) {

                                if(Date.parse(d.createdAto) >= dateFrom.getTime() && Date.parse(d.createdAto) <= dateTo.getTime())
                                    return true;
                            }
                            return false;
                        });
                    }
                    data = data.filter(d => d.lockerName);
                    data = (status) ? data.filter(d => d.status ===status) : data;
                    let nothingFound = (data.length ===0) ? true : false;
                    this.setState({circular: false, data, nothingFound}); 
                }, 6000);
            });
        });
    }

    handleClean() {
        this.setState({ circular: false,
            dateFrom: null,
            dateTo: null,
            status: null,
            documentValue: '',
            cpf: '',
            data: [],
            nothingFound: false,
            togglePosition: 'left'
         });
    }

    returnFilter() {
        let { documentValue, cpf} = this.state;

        let filter = '';
        if(documentValue)
            filter += `filter[documentValue]=${documentValue}&`;
        if(cpf)
            filter += `filter[cpf]=${cpf}`;

        return (filter) ? filter : null;        
    }

    getcustomerById(currentData) {
        this.setState({showInfo: true, currentData});
    }

    setDialog(showInfo) {
        this.setState({ showInfo });
    }

    render() {
        const { classes } = this.props;
        const { circular, data, color, nothingFound, togglePosition } = this.state;
        let layout;

        return (
            <div className={classes.green}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container justify="space-around">
                        <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="dd/MM/yyyy"
                        margin="normal"
                        id="from"
                        label="Data inicial"
                        value={this.state.dateFrom}
                        onChange={this.handleDateChangeFrom}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        />
                        <KeyboardDatePicker
                        disableToolbar
                        variant="inline"
                        format="dd/MM/yyyy"
                        margin="normal"
                        id="to"
                        label="Data final"
                        value={this.state.dateTo}
                        onChange={this.handleDateChangeTo}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        />  
                    </Grid>
                    <form className={classes.root} noValidate autoComplete="off">
                    <TextField className={classes.green}
                        select
                        label="Status"
                        name="status"
                        value={this.state.status}
                        onChange={this.handleChange}
                        >
                            {this.state.statuses.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                {option.label}
                                </MenuItem>
                            ))}
                    </TextField>
                    <FormControl className={classes.green}>
                        <InputLabel htmlFor="docValue">Número do Documento</InputLabel>
                        <Input
                        value={this.state.documentValue}
                        onChange={this.handleChange}
                        id="docValue"
                        />
                    </FormControl>
                    <FormControl className={classes.green}>
                        <InputLabel htmlFor="cpf">CPF</InputLabel>
                        <Input
                        value={this.state.cpf}
                        onChange={this.handleChange}
                        id="cpf"
                        />
                    </FormControl>
                </form>
                <div>
                    <Button onClick={this.handleSearch} color="primary" autoFocus>
                        Pesquisar
                    </Button>
                    <Button onClick={this.handleClean} color="default" autoFocus>
                        Limpar 
                    </Button>
                    {(!circular && data.length > 0) ?
                    <ToggleButton 
                        onChange={(togglePosition) => this.setState({ togglePosition })}
                    /> : null }
                </div>
                {(circular) ? <div className={classes.rootCircular}>
                                <Circular />
                              </div> : 
                              (togglePosition ==='left') ? <GridContainer>
                                        {(data.length > 0) ? data.map((d, index, arr) => (
                                            <GridItem xs={12} sm={12} md={4}>
                                                <Card>
                                                    <CardHeader color={color[0]} icon>
                                                    <CardIcon color="success" className={classes.rowIcon}>
                                                        <Icon>content_copy</Icon>
                                                        {d.id.toUpperCase()}
                                                        <IconButton onClick={() => this.getcustomerById(d)} >
                                                            <Visibility className={classes.iconView}/>
                                                        </IconButton>
                                                    </CardIcon>
                                                    </CardHeader>
                                                    <CardBody>
                                                        <div className={classes.rowIcon}><ViewModule/><b>{(d.lockerName) ? d.lockerName : '-'}</b></div>
                                                        <div className={classes.rowIcon}><Person/><b>{(d.name) ? d.name : '-'}</b></div>
                                                        <div className={classes.rowIcon}><Phone/><b>{(d.phone) ? d.phone : '-'}</b></div>
                                                        <div className={classes.rowIcon}><Info/><b>{(d.status) ? d.status : '-'}</b></div>
                                                        <div className={classes.rowIcon}><Description/><b>{(d.documentValue) ? d.documentValue : '-'}</b></div>
                                                        <div className={classes.rowIcon}><Today/><b>{(d.createdAto) ? <Moment format="DD/MM/YYYY HH:mm:SS">{d.createdAto}</Moment> : '-'}</b></div>
                                                        <div className={classes.rowIcon}><Update/><b>{(d.updatedAto) ? <Moment format="DD/MM/YYYY HH:mm:SS">{d.updatedAto}</Moment> : '-'}</b></div>
                                                    </CardBody>
                                                    {/* <CardFooter> */}
                                                    
                                                    {/* </CardFooter> */}
                                                </Card>
                                            </GridItem>
                                        )) : (nothingFound) ? <h6 className={classes.note}><b>No items found on this search!</b></h6> : null }
                                    </GridContainer> : <Orders lockerId={this.props.lockerId} />}
                </MuiPickersUtilsProvider>
                {(this.state.showInfo) ? <SearchInfo
                    open={this.state.showInfo}
                    data={this.state.currentData}
                    onChange={this.setDialog}
                /> : null}
                
            </div>
        );
    }
}
export default withStyles(useStyles) (SearchSocicam);